import { rei } from "@/services/api"

class MinutasService {
  static getMinuta (params = null) {
    if (params == null) {
      return rei.get(`minuta`).then(res => res.data)
    } else {
      let query = []
      query.push(params.perPage ? 'perPage=' + params.perPage : '')
      query.push(params.page ? 'page=' + params.page : '')
      query.push(params.descricao ? 'descricao=' + params.descricao : '')
      query.push(params.titulo ? 'titulo=' + params.titulo : '')
      query.push(params.cartorio_id ? 'cartorio_id=' + params.cartorio_id : '')
      query.push(params.tipo_registro ? 'tipo_registro=' + params.tipo_registro : '')
      return rei.get(`minuta?${query.join('&')}`).then((res) => res.data)
    }
  }

  static saveMinuta (minuta) {
    return rei.post(`minuta`, minuta).then(res => res.data)
  }

  static updateMinuta (minuta, id) {
    return rei.put(`minuta/${id}`, minuta).then(res => res.data)
  }

  static excludeMinuta (id) {
    return rei.delete(`minuta/${id}`)
  }
}

export default MinutasService
